import { styled, css } from "../../../../../../../../../styles";

// Components

export const MultiSelectContainer = styled("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  ".ant-select": {
    height: "42px !important",
  },
});

// Label | value | (jump to) | remove: the header row and every option share these columns.
const optionGrid = {
  width: "100%",
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) 120px 32px",
  columnGap: "12px",
  alignItems: "start",

  variants: {
    jump: {
      true: { gridTemplateColumns: "minmax(0, 1fr) 120px 210px 32px" },
    },
  },
} as const;

export const Option = styled("div", { position: "relative", ...optionGrid });

export const HeadersRow = styled("div", {
  ...optionGrid,
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",
});

export const textInputCss = css({
  width: "100%",
});

export const valueInputCss = css({
  width: "100%",
});

export const RemoveButtonCss = css({
  height: "42px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    heigth: "42px",
    width: "20px",
    backgroundColor: "rgba(248, 248, 248, 0.8)",

    color: "black",
    borderColor: " transparent",

    "&:hover": {
      backgroundColor: "gray",
      color: "white",
      borderColor: " transparent",
    },
  },
});

export const AddOptionContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
});

export const ConditionalHeaders = styled("div", {});

export const LabelsHeader = styled("div", {});

export const ValuesHeader = styled("div", {});

export const ConditionalSelectContainer = styled("div", {});

export const RemoveButtonContainer = styled("div", {
  gridColumn: "-2",
});
